import React, { Component } from 'react';
import styles from "./breakdown.module.scss";
import blackInk from "../images/Bitmap_2.png";
import colorInk from "../images/Bitmap.png";
import classNames from "classnames";
import debounce from "lodash/debounce";
import * as ReactDOM from "react-dom";
import hpLogo from "../images/Group 31.png";

let cx = classNames.bind(styles);

class Breakdown extends Component {
    state = {
        visible: false,
    };


    constructor(props) {
        super(props);

        this.traditionalColRef = React.createRef();
        this.orColRef = React.createRef();
        this.instantInkColRef = React.createRef();
    }

    componentDidMount() {
        window.addEventListener("resize", () => this.updateColumnHeight());

        this.updateColumnHeight();

        //this.calculateStats();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        this.updateColumnHeight();
    }

    componentWillMount() {
        this.updateColumnHeight();
    }

    componentWillUnmount() {
        window.removeEventListener("resize", () => this.updateColumnHeight());
    }

    /**
     * Just run through the columns to generate a height
     */
    updateColumnHeight = debounce(() => {
        this.setState({ visible: true });

        //-- Define the columns to test against
        let cols = [this.traditionalColRef, this.orColRef, this.instantInkColRef];

        const filterCols = cols
            //-- Make sure the refs are initialized
            .filter((component) => component != null && component.current != null)
            //-- Map component to element
            .map((component) => ReactDOM.findDOMNode(component.current))
            //-- Filter null data
            .filter((elem) => elem != null);


        if (document.documentElement.clientWidth < 768) {
            filterCols.forEach(function(domNode) {
                domNode.style.minHeight = 'initial';
            });

            return;
        }


        //-- Go through each column and find the tallest element
        let maxHeight = filterCols.reduce(function(acc, domNode) {
            const { height } = domNode.getBoundingClientRect();
            return height > acc ? height : acc;
        }, 0);

        if (maxHeight < 1) {
            return;
        }

        //-- Sync height to columns
        filterCols.forEach(function(domNode) {
            // const {height} = domNode.getBoundingClientRect();
            domNode.style.minHeight = maxHeight + 'px';
        });
    }, 50);


    render() {
        return (
            <div className={styles.priceRow} style={{visibility: this.state.visible ? 'visible' : 'hidden'}}>
                <div ref={this.traditionalColRef} className={cx(styles.widget, styles.traditionalCol)}>
                    <div className={styles.sectionHeader}>
                        <div className={styles.hpLogo}>
                            <img src={hpLogo} alt="HP Logo"/>
                        </div>
                        Traditional Cartridges
                    </div>

                    <div className={styles.widgetContainer}>
                        <div className={styles.subHeader2}>
                            <div className={styles.pageHeading}>
                                {this.props.pagesPerMonth} <span className={styles.pages}>pages</span>
                                <span className={styles.monthly}>monthly</span>
                            </div>
                        </div>
                        <div className={styles.inkBreakDown}>
                            <div className={styles.inkBreakDownRow}>
                                <div className={styles.blackInkCol}>
                                    <img src={blackInk} className={styles.colorInkImg} alt="black Ink"
                                         width={39} height={50}/>
                                    <div className={styles.colorInkText}>{this.props.blackInks} black<span
                                        className={styles.perYear}> per year</span></div>
                                </div>
                                <div className={styles.colorInkCol}>
                                    <img src={colorInk} className={styles.colorInkImg} alt="color Ink"
                                         width={39} height={50}/>
                                    <div className={styles.colorInkText}>{this.props.colorInks} color<span
                                        className={styles.perYear}> per year</span></div>
                                </div>
                            </div>
                        </div>

                        <div className={styles.monthlyPrice}>
                            ${this.props.monthlyCost.toFixed(2)}
                            <span className={styles.monthly}>monthly</span>
                        </div>
                    </div>
                </div>
                <div ref={this.orColRef} className={styles.orCol}>
                    <div className={styles.vLine}/>
                    <div className={styles.versus}>VS</div>
                </div>
                <div ref={this.instantInkColRef}
                     className={cx(styles.widget, styles.subscriptionCol, styles['plan-' + this.props.planId])}>
                    <div className={cx(styles.sectionHeader, styles.alt, styles['plan-' + this.props.planId])}>
                        <div className={styles.hpLogo}>
                            <img src={hpLogo} alt="HP Logo"/>
                        </div>
                        HP Instant Ink
                    </div>

                    <div className={styles.widgetContainer}>
                        <div className={cx(styles.subHeader2, styles.alt)}>
                            <div className={styles.pageHeading}>
                                {this.props.planPages} <span className={styles.pages}>pages</span>
                                <span className={styles.monthly}>monthly</span>
                            </div>
                        </div>

                        <div className={styles.shippingNote}>
                            <div className={styles.shippingNoteNonMobile}>
                                All the cartridges you need delivered to your door.
                            </div>
                            <div className={styles.shippingNoteMobile}>All the cartridges you need. One low monthly
                                price.
                            </div>
                        </div>


                        <div className={cx(styles.monthlyPrice, styles.alt)}>
                            {this.props.planPrice}
                            <span className={styles.monthly}>monthly</span>
                        </div>
                    </div>

                </div>
            </div>
        );
    }
}


export default Breakdown;
